/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_MyHoldings_ParticipantDashboardVestingScheduleDto } from '../models/Wealthlane_AwardService_Dtos_MyHoldings_ParticipantDashboardVestingScheduleDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantVestingScheduleService {

    /**
     * @returns Wealthlane_AwardService_Dtos_MyHoldings_ParticipantDashboardVestingScheduleDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardVestingSchedule(): CancelablePromise<Wealthlane_AwardService_Dtos_MyHoldings_ParticipantDashboardVestingScheduleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/vesting-schedule',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
